const columns = [
    {
        title: 'Message',
        dataIndex: 'changes',

    },

    {
        title: 'Created Date',
        dataIndex: 'timestamp',
        sorter: true
    },

];


export default columns;